const ReportIndex =() => {
    return (
        'report-index'
    )
}

export  default ReportIndex;